const darkTheme = {
  name: 'dark',
  isDark: true
}

export type DarkThemeType = typeof darkTheme
export { darkTheme }
